import { LoadingOutlined } from "@ant-design/icons";
import { Button, Form, Input, Modal, Select, Spin } from "antd";
import React, { useEffect, useState } from "react";

const { Option } = Select;

function ScalesFilterModal(props) {
  const [submit, setSubmit] = useState(false);
  const [form] = Form.useForm();
  useEffect(() => {
    if (props.visible) {
      props.filterBy?.name &&
        form.setFields([{ name: "name", value: props.filterBy?.name }]);
      props.filterBy?.type &&
        form.setFields([{ name: "type", value: props.filterBy?.type }]);
      props.filterBy?.status &&
        form.setFields([{ name: "status", value: props.filterBy?.status }]);
    }
  }, [props.visible]);

  function handleCancel() {
    setSubmit(false);
    props.handleCancel();
    form.resetFields();
  }

  const onFinish = (values) => {
    setSubmit(true);
    props.handleOk(values);
    handleCancel();
  };

  return (
    <Modal
      title="Filter Scales"
      visible={props.visible}
      onCancel={() => handleCancel()}
      footer={null}
      destroyOnClose={true}
    >
      <Form
        name="organizationFilter"
        onFinish={onFinish}
        autoComplete="off"
        layout="vertical"
        form={form}
      >
        <Form.Item label="Scale name" name="name">
          <Input placeholder="Scale name" />
        </Form.Item>

        <Form.Item label="Type" name="type">
          <Select placeholder="Select Type">
            <Option key={"default"} value={"default"}>
              Default
            </Option>
            <Option key={"custom"} value={"custom"}>
              Custom
            </Option>
          </Select>
        </Form.Item>

        <Form.Item label="Status" name="status">
          <Select placeholder="Select status">
            <Option key={"active"} value={"Active"}>
              Active
            </Option>
            <Option key={"disabled"} value={"disabled"}>
              Disabled
            </Option>
          </Select>
        </Form.Item>

        <Form.Item style={{ marginBottom: 0 }}>
          <div className=" flex justify-end">
            <Button className="mr-3 w-28" onClick={props.handleCancel}>
              Cancel
            </Button>
            <Button
              className="w-28"
              type="primary"
              htmlType={submit && "submit"}
            >
              {submit ? (
                <Spin
                  size="small"
                  indicator={<LoadingOutlined style={{ color: "#fff" }} spin />}
                />
              ) : (
                "Filter"
              )}
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default ScalesFilterModal;
